import { createReducer } from 'redux-create-reducer'
import * as ActionTypes from '../actions/actionTypes.js'
import omit from 'lodash/fp/omit'

const installedAppsList = {
	isFetching: false,
	didInvalidate: false,
	items: []
}

export const installedApps = createReducer(installedAppsList, {
	[ActionTypes.INSTALLED_APP_LIST_REQUEST](state) {
		return { ...state, isFetching: true, didInvalidate: false }
	},
	[ActionTypes.INSTALLED_APP_LIST_SUCCESS](state, { payload }) {
		return {
			...state,
			isFetching: false,
			didInvalidate: false,
			items: payload.items,
			lastUpdated: payload.receivedAt
		}
	},
	[ActionTypes.INSTALLED_APP_LIST_FAILURE](state, { payload }) {
		return { ...state }
	},
	[ActionTypes.APP_UNINSTALL_SUCCESS](state, { payload }) {
		return {
			...state,
			items: omit(...state.items, payload.id)
		}
	},
	[ActionTypes.APP_INSTALL_SUCCESS](state, { payload }) {
		return {
			...state,
			items: [...state.items, payload.id]
		}
	}
})



// WEBPACK FOOTER //
// ./src/reducers/installedApps.js